export const painPoints = [
  {
    emoji: '💀',
    title: 'Chocás con "el muro" y abandonás',
    desc: 'Tu cerebro activa el modo supervivencia y te ordena parar mucho antes de que el músculo llegue a su límite real. No lo ves venir y no sabés cómo atravesarlo.',
  },
  {
    emoji: '🌀',
    title: 'Pensamientos negativos en bucle',
    desc: 'Una voz interna que repite "no podés", "pará", "para qué seguir". Cada zancada se convierte en una negociación que siempre perdés cuando más importa.',
  },
  {
    emoji: '😰',
    title: 'Ansiedad paralizante antes de competir',
    desc: 'Noches sin dormir, estómago cerrado y piernas pesadas. Los nervios pre-carrera destruyen semanas de preparación en pocas horas antes del disparo de salida.',
  },
  {
    emoji: '📉',
    title: 'Entrenás más y rendís igual o menos',
    desc: 'Sumás kilómetros pero las marcas no bajan. La frustración se acumula y el agotamiento mental te hace dudar de todo tu proceso de entrenamiento.',
  },
  {
    emoji: '🔁',
    title: 'Abandono crónico de objetivos',
    desc: 'Empezás fuerte cada temporada y a mitad de ciclo perdés motivación. No es pereza, es que tu sistema de recompensa mental no está entrenado para el largo plazo.',
  },
  {
    emoji: '🧱',
    title: 'No lográs entrar en el Estado de Flow',
    desc: 'Otros corredores describen una sensación de "volar" donde todo es fácil. Vos corrés siempre desde el esfuerzo consciente y el sufrimiento. Nunca desde la zona.',
  },
];
